// extracted by mini-css-extract-plugin
export var popper = "_87-0";